// material
import React, { useEffect, useState } from 'react';
import { subDays } from 'date-fns';
import { Box, Grid, Container, Typography, Card, Stack, Tab, IconButton } from '@mui/material';
import FilterListIcon from '@mui/icons-material/FilterList';
import { ReactComponent as OverviewIcon } from '../../public/static/ai/overview_icon.svg';
import { ReactComponent as MapIcon } from '../../public/static/ai/map_icon.svg';
import { ReactComponent as TicketsIcon } from '../../public/static/ai/ticket_stats_icon.svg';
import { ReactComponent as TransactionsIcon } from '../../public/static/ai/transactions_icon.svg';
import { ReactComponent as DeviceAnalyticsIcon } from '../../public/static/ai/device_analytics_icon.svg';
import { ReactComponent as CampaignsIcon } from '../../public/static/ai/campaign_icon.svg';
import { ReactComponent as SchemesIcon } from '../../public/static/ai/schemes_icon.svg';
import { ReactComponent as TriggeredCampaignIcon } from '../../public/static/ai/Triggered_icon.svg';

import {
  GetOrganizationDeviceStats,
  GetOrganizationTransactionStats,
  GetOrganizationMerchantStats,
  GetTransactionsTrend
} from '../network/Organization';
import { getDateINYMD, getDateInddMMYYYY } from '../utils/formatTime';
import { useAuth } from '../components/customContextProviders/AuthContext';
// components
import Page from '../components/Page';
import { DateRangePickerDialog, ExportDataModal } from '../components/_dashboard/app';
import { SoundBoxDevicesStats, DeviceOrderdButtons } from '../components/_dashboard/soundbox';
import SoundBoxTransactions from './SoundBoxTransactions';
import DashboardNavbar from '../layouts/dashboard/DashboardNavbar';
import DashboardSidebar from '../layouts/dashboard/DashboardSidebar';
import { SnackBarAlert } from '../components/HelperComponents';
import {
  DateSelectorModal,
  AnnounceTrendGraph,
  TransactionAmountGraph,
  MerchantDonut,
  DevicesDonut,
  MapWithMarker
} from '../components/_dashboard/trendGraphs';
import DeviceHealth from '../components/chanakya/DeviceHealth';
import { GetCampaignStats } from '../network/Campaigns';
import CampaignDonut from '../components/chanakya/CampaignDonut';
import { GetVendorStats } from '../network/Vendor';
import VendorPayments from '../components/chanakya/VendorPayments';
import { GetDeviceHeartBeat, GetDeviceLiveStatus, GetGeoLocation } from '../network/Device';
import TicketsDonut from '../components/chanakya/TicketsDonut';
import TransactionStatsData from '../components/chanakya/TransactionStatsData';
import CampaignStatsGraph from '../components/_dashboard/soundbox/CampaignStatsGraph';
import SchemeDonut from '../components/chanakya/SchemeDonut';
import { GetSchemeStatus } from '../network/Scheme';
import { GetTicketStats } from '../ticketManagement/network/Ticket';
import { parseTicketStatsPayload } from '../ticketManagement/utils/ticketManagementUtils';
import ReusableBarChart from '../components/chanakya/ReusableBarChart';

export default function ChanakyaLandingPage() {
  const [open, setOpen] = useState(false);
  const { allOrganizationList } = useAuth();
  const [transactionStatsData, setTransactionStatsData] = useState({});
  const [isDateRangeDialogOpen, setIsDateRangeDialogOpen] = useState(false);
  const [customDateSelectedString, setCustomDateSelectedString] = useState('');
  const [isExportDataModalOpen, setIsExportDataModalOpen] = useState(false);
  const [statsActive, setStatsActive] = useState('1');
  const [isDateSelectorModalOpen, setIsDateSelectorModalOpen] = useState(false);

  const [isSnackBarAlertOpen, setIsSnackBarAlertOpen] = useState(false);
  const [snackBarMetas, setSnackBarMetas] = useState({
    title: '',
    message: '',
    severity: 'info',
    handleClose: null
  });

  const [soundboxStatsData, setSoundboxStatsData] = useState({
    merchantStats: {},
    deviceStats: {}
  });

  const [ticketStats, setTicketStats] = useState({});
  const [deviceStatusCount, setDeviceStatusCount] = useState('');
  const [transactionTrendData, setTransactionTrendData] = useState([]);
  const [campaignStats, setCampaignStats] = useState(null);
  const [vendorStatsByTab, setVendorStatsByTab] = useState({});
  const [schemeStatsByTab, setSchemeStatsByTab] = useState({});
  const [location, setLocation] = useState({ lat: '', lng: '' });
  const [loc1, setLoc1] = useState({ lat: '', lng: '' });
  useEffect(() => {
    getDashboardDeviceStats();
    getTransactionStats(getDateINYMD(subDays(new Date(), 7)), getDateINYMD(new Date()));
    getOrganizationMerchantStats();
    fetchTransactionAnalytics(getDateINYMD(subDays(new Date(), 7)), getDateINYMD(new Date()));
    getCampaignStats();
    fetchVendorStats(getDateINYMD(subDays(new Date(), 7)), getDateINYMD(new Date()));
    fetchDeviceHeartBeat();
    fetchSchemeStats(getDateINYMD(subDays(new Date(), 7)), getDateINYMD(new Date()));
    fetchTicketStats('Today');
    fetchDevicesStatus([
      'fdfc9c07-f640-4ee3-90a4-00802a9257fa',
      '1fee97c2-e574-4db4-b2c9-e9797296dff2'
    ]);
    return () => {};
  }, []);

  const handleStatsTabChange = (_event, newValue) => {
    setTransactionStatsData({});
    if (newValue === '1') getTransactionStats(getDateINYMD(new Date()), getDateINYMD(new Date()));
    else if (newValue === '2')
      getTransactionStats(getDateINYMD(subDays(new Date(), 30)), getDateINYMD(new Date()));
    else if (newValue === '3') setIsDateRangeDialogOpen(true);

    setStatsActive(newValue);
  };

  function fetchDevicesStatus(deviceIds = []) {
    Promise.all(deviceIds.map((id) => GetDeviceLiveStatus(id)))
      .then((responses) => {
        const onlineCount = responses.filter((res) => res?.data?.isOnline).length;

        setDeviceStatusCount(onlineCount); // 0, 1, or 2
      })
      .catch((err) => {});
  }

  function getDashboardDeviceStats() {
    GetOrganizationDeviceStats()
      .then((res) => {
        setSoundboxStatsData((soundboxStatsData) => ({
          ...soundboxStatsData,
          deviceStats: res?.data
        }));
      })
      .catch((_error) => {});
  }

  function getOrganizationMerchantStats() {
    GetOrganizationMerchantStats()
      .then((res) => {
        setSoundboxStatsData((soundboxStatsData) => ({
          ...soundboxStatsData,
          merchantStats: res?.data
        }));
      })
      .catch((_err) => {});
  }

  function onDateRangeSelectedAction(fromDate, todate) {
    if (fromDate === undefined || todate === undefined || fromDate === null || todate === null) {
      setSnackBarMetas((prevState) => ({
        ...prevState,
        title: "You haven't selected the Date Range.",
        severity: 'warning'
      }));
      setIsSnackBarAlertOpen(true);

      setStatsActive('1');
      getTransactionStats(getDateINYMD(new Date()), getDateINYMD(new Date()));
      return false;
    }

    setCustomDateSelectedString(
      getDateInddMMYYYY(fromDate).concat(' -to- ').concat(getDateInddMMYYYY(todate))
    );
    getTransactionStats(getDateINYMD(fromDate), getDateINYMD(todate));
  }

  function getTransactionStats(fromDate, toDate) {
    GetOrganizationTransactionStats(fromDate, toDate)
      .then((res) => {
        setTransactionStatsData(res?.data?.result?.data);
      })
      .catch((_error) => {});
  }

  function fetchTransactionAnalytics(startDate, endDate) {
    GetTransactionsTrend(startDate, endDate)
      .then((res) => {
        setTransactionTrendData(res?.data?.data);
      })
      .catch((err) => {});
  }

  const handleDateSelectorApply = ({ startDate, endDate }) => {
    fetchTransactionAnalytics(startDate, endDate);
    getTransactionStats(startDate, endDate);
  };

  const getCampaignStats = () => {
    GetCampaignStats()
      .then((res) => {
        setCampaignStats(res?.data);
      })
      .catch((err) => {
        console.log(err, 'err');
      });
  };

  const statusMap = Object.fromEntries(
    soundboxStatsData?.deviceStats?.totalDevicesByStatus?.map((item) => [
      item.status,
      Number(item.count)
    ]) || []
  );

  const fetchVendorStats = (start, end) => {
    GetVendorStats(start, end)
      .then((res) => {
        console.log('AAAAAAAAAAAAa', res?.data);
        setVendorStatsByTab(res?.data);
      })
      .catch((err) => {});
  };

  function fetchDeviceHeartBeat() {
    GetDeviceHeartBeat('1fee97c2-e574-4db4-b2c9-e9797296dff2')
      .then((res) => {
        fetchDeviceGeoLocation(
          res?.data?.[0] || res?.data?.data?.[0],
          '1fee97c2-e574-4db4-b2c9-e9797296dff2'
        );
      })
      .catch((_err) => {});

    GetDeviceHeartBeat('fdfc9c07-f640-4ee3-90a4-00802a9257fa')
      .then((res) => {
        fetchDeviceGeoLocation(
          res?.data?.[0] || res?.data?.data?.[0],
          'fdfc9c07-f640-4ee3-90a4-00802a9257fa'
        );
      })
      .catch((_err) => {});
  }

  function fetchDeviceGeoLocation(heartbeat, id) {
    const payload = {
      homeMobileCountryCode: heartbeat?.lastHeartbeat?.MCC,
      homeMobileNetworkCode: heartbeat?.lastHeartbeat?.MNC,
      radioType: 'lte',
      carrier: heartbeat?.lastHeartbeat?.OPERATOR,
      considerIp: true,
      cellTowers: [
        {
          cellId: heartbeat?.lastHeartbeat?.CID,
          locationAreaCode: heartbeat?.lastHeartbeat?.TAC,
          mobileCountryCode: heartbeat?.lastHeartbeat?.MCC,
          mobileNetworkCode: heartbeat?.lastHeartbeat?.MNC
        }
      ]
    };

    GetGeoLocation(payload)
      .then((res) => {
        if (id === '1fee97c2-e574-4db4-b2c9-e9797296dff2') {
          setLocation({
            lat: res?.data?.location?.lat,
            lng: res?.data?.location?.lng
          });
        } else if (id === 'fdfc9c07-f640-4ee3-90a4-00802a9257fa') {
          setLoc1({
            lat: res?.data?.location?.lat,
            lng: res?.data?.location?.lng
          });
        }
      })
      .catch((err) => {
        // setSnackBarMetas((prevState) => ({
        //   ...prevState,
        //   title: `Failed to fetch Geo-Location. ${parseValidationErrorMessage(err)}`,
        //   severity: 'error'
        // }));
        // setIsSnackBarAlertOpen(true);
      });
  }

  const fetchSchemeStats = (start, end) => {
    GetSchemeStatus(start, end)
      .then((res) => {
        setSchemeStatsByTab(res?.data?.counts);
      })
      .then((err) => {});
  };

  const fetchTicketStats = (range, startDate, endDate) => {
    if (range === 'Between Dates' && !startDate) {
      setIsDateRangeDialogOpen(true);
      return;
    }
    const statsParams = {};
    if (range !== undefined) statsParams.range = range;
    if (startDate !== undefined) statsParams.startDate = startDate;
    if (endDate !== undefined) statsParams.endDate = endDate;

    GetTicketStats(statsParams)
      .then((response) => {
        setTicketStats(parseTicketStatsPayload(response));
      })
      .catch((err) => {
        console.log('Error fetching ticket stats: ', err);
      });
  };

  return (
    <Page title="AudioCube" data-cy="soundbox-dashboard">
      <DashboardNavbar onOpenSidebar={() => setOpen(true)} />
      <DashboardSidebar isOpenSidebar={open} onCloseSidebar={() => setOpen(false)} />

      <Container maxWidth="false">
        <Card
          sx={{
            height: { xl: '280px', xlm: '290px', lg: '290px' },
            width: '100%',
            flexShrink: 0,
            px: 2.5,
            display: 'flex',
            alignItems: 'flex-start',
            flexDirection: 'column ',
            mb: 2,
            mt: 1
          }}
        >
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0, mt: 1 }}>
            <OverviewIcon
              style={{
                width: 40,
                height: 40,
                color: '#457AEF'
              }}
            />

            <Typography
              sx={{
                fontWeight: 700,
                color: '#171D40',
                fontSize: '14px',
                lineHeight: '1',
                pb: 0.5
              }}
            >
              Overview
            </Typography>
          </Box>
          <Stack direction="row" spacing={2} sx={{ width: '100%' }}>
            <Card
              elevation={0}
              sx={{
                p: 2,
                borderRadius: 1.5,
                textAlign: 'center',
                boxShadow: '0px 8px 24px rgba(0,0,0,0.08)',
                width: '20%',
                display: 'flex',
                justifyContent: 'center'
              }}
            >
              <MerchantDonut
                assigned={
                  soundboxStatsData?.merchantStats?.totalMerchants -
                  soundboxStatsData?.merchantStats?.unAssignedMerchants
                }
                unassigned={soundboxStatsData?.merchantStats?.unAssignedMerchants}
                total={soundboxStatsData?.merchantStats?.totalMerchants}
              />
            </Card>
            <Card
              elevation={0}
              sx={{
                p: 2,
                borderRadius: 1.5,
                textAlign: 'center',
                boxShadow: '0px 8px 24px rgba(0,0,0,0.08)',
                width: '20%',
                display: 'flex',
                justifyContent: 'center'
              }}
            >
              <DevicesDonut
                onboarded={statusMap.onboarded}
                assigned={statusMap.assigned}
                total={soundboxStatsData?.deviceStats?.totalDevices}
              />
            </Card>
            <Card
              elevation={0}
              sx={{
                p: 2,
                borderRadius: 1.5,
                textAlign: 'center',
                boxShadow: '0px 8px 24px rgba(0,0,0,0.08)',
                width: '20%'
              }}
            >
              <DeviceHealth
                totalDevices={soundboxStatsData?.deviceStats?.totalDevices}
                online={deviceStatusCount}
                offline={soundboxStatsData?.deviceStats?.totalDevices - deviceStatusCount}
              />
            </Card>
            <Card
              elevation={0}
              sx={{
                p: 2,
                borderRadius: 1.5,
                textAlign: 'center',
                boxShadow: '0px 8px 24px rgba(0,0,0,0.08)',
                width: '20%'
              }}
            >
              <CampaignDonut
                active={campaignStats?.activeCampaigns}
                total={campaignStats?.totalCampaigns}
                inActive={campaignStats?.inactiveCampaigns}
                ir={40}
                or={52}
              />
            </Card>
            <Card
              elevation={0}
              sx={{
                p: 2,
                borderRadius: 1.5,
                textAlign: 'center',
                boxShadow: '0px 8px 24px rgba(0,0,0,0.08)',
                width: '20%'
              }}
            >
              <VendorPayments
                validityExpiring={vendorStatsByTab?.summary?.totalValidityExpiringVendors}
                pending={vendorStatsByTab?.summary?.pendingPaymentVendors}
                overdue={vendorStatsByTab?.summary?.overduePaymentVendors}
              />
            </Card>
          </Stack>
        </Card>

        <Card
          sx={{
            height: { xl: '320px', xlm: '350px', lg: '330px' },
            width: '100%',
            px: 2.5,
            display: 'flex',
            alignItems: 'flex-start',
            flexDirection: 'column',
            my: 2
          }}
        >
          <Box
            sx={{
              width: '100%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              mb: 0
            }}
          >
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0, mt: 1 }}>
              <TransactionsIcon
                style={{
                  width: 40,
                  height: 40,
                  color: '#457AEF'
                }}
              />

              <Typography
                sx={{
                  fontWeight: 700,
                  color: '#171D40',
                  fontSize: '14px',
                  lineHeight: '1',
                  pb: 0.5
                }}
              >
                Transaction Analytics
              </Typography>
            </Box>

            {/* FILTER BUTTON */}
            <Box
              onClick={() => setIsDateSelectorModalOpen(true)}
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                cursor: 'pointer',
                fontWeight: 600,
                transition: 'all 0.2s ease',
                padding: '4px 6px',
                borderRadius: '6px',
                '&:hover': {
                  backgroundColor: 'rgba(0,0,0,0.05)'
                }
              }}
            >
              <FilterListIcon sx={{ color: '#7D8A96' }} />
            </Box>
          </Box>
          <Stack direction="row" spacing={2} sx={{ width: '100%', height: '80%' }}>
            <Card
              elevation={0}
              sx={{
                p: 2,
                borderRadius: 1.5,
                textAlign: 'center',
                boxShadow: '0px 8px 24px rgba(0,0,0,0.08)',
                width: '20%',
                display: 'flex',
                justifyContent: 'center',
                height: '100%'
              }}
            >
              <TransactionStatsData
                totalAmount={transactionStatsData?.totalSum}
                numberOfTransactions={transactionStatsData?.totalCount}
              />
            </Card>
            <Card
              elevation={0}
              sx={{
                p: 2,
                borderRadius: 1.5,
                textAlign: 'center',
                boxShadow: '0px 8px 24px rgba(0,0,0,0.08)',
                width: '80%',
                display: 'flex',
                justifyContent: 'center',
                height: '100%'
              }}
            >
              <AnnounceTrendGraph trendData={transactionTrendData} />
              <TransactionAmountGraph trendData={transactionTrendData} />
            </Card>
          </Stack>
        </Card>
        <Card
          sx={{
            height: { xl: '320px', xlm: '350px', lg: '350px' },
            width: '100%',
            px: 2.5,
            display: 'flex',
            alignItems: 'flex-start',
            flexDirection: 'column'
          }}
        >
          <Grid
            container
            spacing={2}
            sx={{
              flex: 1,
              width: '100%',
              margin: 0
            }}
          >
            {/* MAP SECTION */}
            <Grid
              size={{ xs: 12, sm: 4, md: 4, xl: 4, lg: 4 }}
              sx={{
                height: '100%',
                width: '100%',
                display: 'flex',
                flexDirection: 'column',
                padding: '0 !important'
              }}
            >
              {/* Header */}
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 0, mt: 1 }}>
                <MapIcon
                  style={{
                    width: 40,
                    height: 40,
                    color: '#457AEF'
                  }}
                />
                <Typography
                  sx={{
                    fontWeight: 700,
                    color: '#171D40',
                    fontSize: '14px',
                    lineHeight: '1',
                    pb: 0.5
                  }}
                >
                  Maps
                </Typography>
              </Box>

              {/* Map Container */}
              <Box
                sx={{
                  flex: 1,
                  width: '100%'
                }}
              >
                <MapWithMarker
                  customHeight="92%"
                  latitude={location?.lat}
                  longitude={location?.lng}
                  secondLatitude={loc1?.lat}
                  secondLongitude={loc1?.lng}
                />
              </Box>
            </Grid>

            {/* USER DATA SECTION */}
            <Grid
              size={{ xs: 12, sm: 5, md: 5, xl: 5, lg: 4 }}
              sx={{
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                padding: '0 !important'
              }}
            >
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 0, mt: 1 }}>
                <TicketsIcon
                  style={{
                    width: 40,
                    height: 40,
                    color: '#457AEF'
                  }}
                />
                <Typography
                  sx={{
                    fontWeight: 700,
                    color: '#171D40',
                    fontSize: '14px',
                    lineHeight: '1',
                    pb: 0.5
                  }}
                >
                  Customer Support Analytics
                </Typography>
              </Box>
              <Card
                elevation={0}
                sx={{
                  p: 2,
                  borderRadius: 1.5,
                  boxShadow: '0px 8px 24px rgba(0,0,0,0.08)',
                  width: '100%',
                  height: '78%'
                }}
              >
                <TicketsDonut
                  closed={ticketStats?.Closed}
                  open={ticketStats?.Open}
                  pending={ticketStats?.Pending}
                  resolved={ticketStats?.Resolved}
                  waitingOnBank={ticketStats?.['Waiting On Customer']}
                />
              </Card>
            </Grid>

            <Grid
              size={{ xs: 12, sm: 3, md: 3, xl: 3, lg: 4 }}
              sx={{
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                padding: '0 !important'
              }}
            >
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 0, mt: 1 }}>
                <DeviceAnalyticsIcon
                  style={{
                    width: 40,
                    height: 40,
                    color: '#457AEF'
                  }}
                />
                <Typography
                  sx={{
                    fontWeight: 700,
                    color: '#171D40',
                    fontSize: '14px',
                    lineHeight: '1',
                    pb: 0.5
                  }}
                >
                  Device Analytics
                </Typography>
              </Box>
              <Card
                elevation={0}
                sx={{
                  p: 2,
                  borderRadius: 1.5,
                  boxShadow: '0px 8px 24px rgba(0,0,0,0.08)',
                  width: '100%',
                  height: '78%'
                }}
              >
                <ReusableBarChart
                  data={[
                    {
                      label: 'Active',
                      value: 1,
                      details:
                        'Devices that have been online and transmitting data consistently over the last 30 days.'
                    },
                    {
                      label: 'Intermittent',
                      value: 1,
                      details:
                        'Devices that are live but show irregular connectivity or usage during the last 30 days.'
                    },
                    {
                      label: 'Inactive',
                      value: 3,
                      details:
                        'Devices that have remained offline or reported no activity in the last 30 days.'
                    }
                  ]}
                  height="100%"
                  barWidth={40}
                  barCategoryGap={24}
                  bars={[
                    {
                      gradient: {
                        id: 'active',
                        stops: [
                          { offset: '0%', color: '#95E22E' },
                          { offset: '100%', color: '#FFFFFF' }
                        ]
                      }
                    },
                    {
                      gradient: {
                        id: 'liveInactive',
                        stops: [
                          { offset: '0%', color: '#FFBB8C' },
                          { offset: '100%', color: '#FFE9DA' }
                        ]
                      }
                    },
                    {
                      gradient: {
                        id: 'inactive',
                        stops: [
                          { offset: '0%', color: '#FF3C00' },
                          { offset: '100%', color: '#FFC29C' }
                        ]
                      }
                    }
                  ]}
                />
              </Card>
            </Grid>
          </Grid>
        </Card>

        <Card
          sx={{
            height: { xl: '320px', xlm: '350px', lg: '330px' },
            width: '100%',
            px: 2.5,
            display: 'flex',
            alignItems: 'flex-start',
            flexDirection: 'column',
            my: 2
          }}
        >
          <Box
            sx={{
              width: '100%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              mb: 0,
              gap: 3
            }}
          >
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0, mt: 1, width: '20%' }}>
              <SchemesIcon
                style={{
                  width: 40,
                  height: 40,
                  color: '#457AEF'
                }}
              />

              <Typography
                sx={{
                  fontWeight: 700,
                  color: '#171D40',
                  fontSize: '14px',
                  lineHeight: '1',
                  pb: 0.5
                }}
              >
                Schemes
              </Typography>
            </Box>

            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0, mt: 1, width: '20%' }}>
              <CampaignsIcon
                style={{
                  width: 40,
                  height: 40,
                  color: '#457AEF'
                }}
              />

              <Typography
                sx={{
                  fontWeight: 700,
                  color: '#171D40',
                  fontSize: '14px',
                  lineHeight: '1',
                  pb: 0.5
                }}
              >
                Campaigns
              </Typography>
            </Box>

            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0, mt: 1, width: '58%' }}>
              <TriggeredCampaignIcon
                style={{
                  width: 40,
                  height: 40,
                  color: '#457AEF'
                }}
              />

              <Typography
                sx={{
                  fontWeight: 700,
                  color: '#171D40',
                  fontSize: '14px',
                  lineHeight: '1',
                  pb: 0.5
                }}
              >
                Triggered Campaigns
              </Typography>
            </Box>

            {/* FILTER BUTTON */}
            <Box
              onClick={() => setIsDateSelectorModalOpen(true)}
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                cursor: 'pointer',
                fontWeight: 600,
                transition: 'all 0.2s ease',
                padding: '4px 6px',
                borderRadius: '6px',
                '&:hover': {
                  backgroundColor: 'rgba(0,0,0,0.05)'
                }
              }}
            >
              <FilterListIcon sx={{ color: '#7D8A96' }} />
            </Box>
          </Box>
          <Stack direction="row" spacing={2} sx={{ width: '100%' }}>
            <Card
              elevation={0}
              sx={{
                p: 2,
                borderRadius: 1.5,
                textAlign: 'center',
                boxShadow: '0px 8px 24px rgba(0,0,0,0.08)',
                width: '20%',
                display: 'flex',
                justifyContent: 'center',
                height: '100%'
              }}
            >
              <SchemeDonut
                active={schemeStatsByTab?.active}
                total={schemeStatsByTab?.active + schemeStatsByTab?.inactive}
                inActive={schemeStatsByTab?.inactive}
                ir={50}
                or={65}
              />
            </Card>
            <Card
              elevation={0}
              sx={{
                p: 2,
                borderRadius: 1.5,
                textAlign: 'center',
                boxShadow: '0px 8px 24px rgba(0,0,0,0.08)',
                width: '20%',
                display: 'flex',
                justifyContent: 'center',
                height: '100%'
              }}
            >
              <CampaignDonut
                active={campaignStats?.activeCampaigns}
                total={campaignStats?.totalCampaigns}
                inActive={campaignStats?.inactiveCampaigns}
                ir={50}
                or={65}
              />{' '}
            </Card>
            <Card
              elevation={0}
              sx={{
                p: 2,
                borderRadius: 1.5,
                textAlign: 'center',
                boxShadow: '0px 8px 24px rgba(0,0,0,0.08)',
                width: '60%',
                display: 'flex',
                justifyContent: 'center',
                height: '100%'
              }}
            >
              <CampaignStatsGraph />
            </Card>
          </Stack>
        </Card>

        <Box>
          <Grid container spacing={3}>
            <Box sx={{ width: '100%' }} data-cy="transactions-list">
              <SoundBoxTransactions />
            </Box>
          </Grid>
        </Box>

        <ExportDataModal
          opneAssignedModal={isExportDataModalOpen}
          handleClose={() => setIsExportDataModalOpen(false)}
        />

        <SnackBarAlert
          open={isSnackBarAlertOpen}
          title={snackBarMetas?.title}
          message={snackBarMetas?.message}
          severity={snackBarMetas?.severity}
          handleClose={() => setIsSnackBarAlertOpen(false)}
        />

        <DateRangePickerDialog
          openDateRangeModal={isDateRangeDialogOpen}
          handleClose={() => setIsDateRangeDialogOpen(false)}
          onAction={(fromDate, toDate) => onDateRangeSelectedAction(fromDate, toDate)}
        />
        <DateSelectorModal
          openDateSelectorModal={isDateSelectorModalOpen}
          handleClose={() => setIsDateSelectorModalOpen(false)}
          onApply={handleDateSelectorApply}
        />
      </Container>
    </Page>
  );
}
